<template>
  <div>
    <!-- Demo block -->
    <v-row class="">
      <!-- Prediction -->
      <v-col class="col-lg-6">
        <!-- Prediction -->
        <div class="card card-custom text-no-wrap mb-5">
          <div class="card-header border-0 d-flex justify-content-end">
            <h5 class="font-weight-bolder text-dark">
              <img src="/pages/dashboard/saving.svg" alt="" /><span
                >Prediction</span
              >
            </h5>
          </div>
          <div class="card-body pt-0 d-flex justify-content-end">
            <!-- Prevented Clicks -->
            <div class="d-flex align-items-center my-0 flex xs4">
              <div
                class="d-flex flex-column text-right"
                style="font-weight:900"
              >
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ formatNumbers(getBlocks()["predicted"].clicks) }}
                  <span
                    class="font-size-h5"
                    v-if="getBlocks()['predicted'].clicks_percent"
                    >({{ getBlocks()["predicted"].clicks_percent }}%)</span
                  >
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Prevented Clicks
                </span>
              </div>
            </div>
            <!-- /Prevented Clicks -->

            <!-- Saved money -->
            <div
              class="d-flex align-items-center my-0 flex xs4 justify-content-end"
            >
              <div
                class="d-flex flex-column text-right"
                style="font-weight:900"
              >
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ drawCurrency(getBlocks()["predicted"].money) }}
                  <span
                    class="font-size-h5"
                    v-if="getBlocks()['predicted'].money_percent"
                    >({{ getBlocks()["predicted"].money_percent }}%)</span
                  >
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Saved Money
                </span>
              </div>
            </div>
            <!-- /Saved money -->
          </div>
        </div>
        <!-- /Prediction -->

        <!-- Potentially Blocked -->
        <div class="card card-custom text-no-wrap mb-5">
          <div class="card-header border-0 d-flex justify-content-end">
            <h5 class="font-weight-bolder text-dark">
              <img src="/pages/dashboard/saving.svg" alt="" /><span
                >Potentially Blocked</span
              >
            </h5>
          </div>
          <div class="card-body pt-0 d-flex justify-content-end">
            <!-- IP's -->
            <div class="d-flex align-items-center flex xs4">
              <div
                class="d-flex flex-column text-right"
                style="font-weight:900"
              >
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ formatNumbers(getBlocks()["predicted"].blocked.ips) }}
                  <span
                    class="font-size-h5"
                    v-if="getBlocks()['predicted'].blocked.ips_percent > 0"
                    >({{ getBlocks()["predicted"].blocked.ips_percent }}%)</span
                  >
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  IP's
                </span>
              </div>
            </div>
            <!-- /IP's -->

            <!-- Placements -->
            <div
              class="d-flex align-items-center flex xs4"
              v-if="
                getBlocks()['predicted'] &&
                  getBlocks()['predicted'].blocked.placements > 0
              "
            >
              <div
                class="d-flex flex-column text-right"
                style="font-weight:900"
              >
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{
                    formatNumbers(getBlocks()["predicted"].blocked.placements)
                  }}
                  <span
                    class="font-size-h5"
                    v-if="
                      getBlocks()['predicted'].blocked.placements_percent > 0
                    "
                    >({{
                      getBlocks()["predicted"].blocked.placements_percent
                    }}%)</span
                  >
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Placements
                </span>
              </div>
            </div>
            <!-- /Placements -->

            <!-- Users -->
            <div class="d-flex align-items-centerflex xs4 justify-content-end">
              <div
                class="d-flex flex-column text-right"
                style="font-weight:900"
              >
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ formatNumbers(getBlocks()["predicted"].blocked.users) }}
                  <span
                    class="font-size-h5"
                    v-if="getBlocks()['predicted'].blocked.users_percent > 0"
                    >({{
                      getBlocks()["predicted"].blocked.users_percent
                    }}%)</span
                  >
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Users
                </span>
              </div>
            </div>
            <!-- /Users -->
          </div>
        </div>
        <!-- /Potentially Blocked -->

        <!-- Potentially Lost -->
        <div class="card card-custom text-no-wrap">
          <div class="card-header border-0 d-flex justify-content-end">
            <h5 class="font-weight-bolder text-dark">
              <img src="/pages/dashboard/saving.svg" alt="" /><span
                >Potentially Lost</span
              >
            </h5>
          </div>
          <div class="card-body pt-0 d-flex justify-content-end">
            <div class="d-flex align-items-center flex xs4 justify-content-end">
              <div
                class="d-flex flex-column text-right"
                style="font-weight:900"
              >
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ formatNumbers(getBlocks()["predicted"].lost_conversions) }}
                  <span
                    class="font-size-h5"
                    v-if="getBlocks()['predicted'].lost_conversions_percent"
                    >({{
                      getBlocks()["predicted"].lost_conversions_percent
                    }}%)</span
                  >
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Orders
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- /Potentially Lost -->
      </v-col>
      <!-- /Prediction -->

      <!-- Real -->
      <v-col class="col-lg-6">
        <!-- Real -->
        <div class="card card-custom text-no-wrap mb-5">
          <div class="card-header border-0 d-flex">
            <h5 class="font-weight-bolder text-dark">
              <img src="/pages/dashboard/block.svg" alt="" /><span>Real</span>
            </h5>
          </div>
          <div class="card-body pt-0 d-flex">
            <!-- Prevented Clicks -->
            <div class="d-flex align-items-center my-0 flex xs4">
              <div class="d-flex flex-column" style="font-weight:900">
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ formatNumbers(getBlocks()["real"].clicks) }}
                  <span
                    class="font-size-h5"
                    v-if="getBlocks()['real'].clicks_percent"
                    >({{ getBlocks()["real"].clicks_percent }}%)</span
                  >
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Prevented Clicks
                </span>
              </div>
            </div>
            <!-- /Prevented Clicks -->

            <!-- Saved money -->
            <div class="d-flex align-items-center my-0 flex xs4">
              <div class="d-flex flex-column" style="font-weight:900">
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ drawCurrency(getBlocks()["real"].money) }}
                  <span
                    class="font-size-h5"
                    v-if="getBlocks()['real'].money_percent"
                    >({{ getBlocks()["real"].money_percent }}%)</span
                  >
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Saved Money
                </span>
              </div>
            </div>
            <!-- /Saved money -->
          </div>
        </div>
        <!-- /Real -->

        <!-- All -->
        <div class="card card-custom text-no-wrap mb-5">
          <div class="card-header border-0 d-flex">
            <h5 class="font-weight-bolder text-dark">
              <img src="/pages/dashboard/saving.svg" alt="" /><span>All</span>
            </h5>
          </div>
          <div class="card-body pt-0 d-flex">
            <!-- IP's  -->
            <div class="d-flex align-items-center flex xs4">
              <div class="d-flex flex-column" style="font-weight:900">
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ formatNumbers(getBlocks()["real"].total.ips) }}
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  IP's
                </span>
              </div>
            </div>
            <!-- /IP's -->

            <!-- Placements -->
            <div
              class="d-flex align-items-center flex xs4"
              v-if="
                getBlocks()['real'] && getBlocks()['real'].total.placements > 0
              "
            >
              <div class="d-flex flex-column" style="font-weight:900">
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ formatNumbers(getBlocks()["real"].total.placements) }}
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Placements
                </span>
              </div>
            </div>
            <!-- /Placements -->

            <!-- Users -->
            <div class="d-flex align-items-centerflex xs4">
              <div class="d-flex flex-column" style="font-weight:900">
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ formatNumbers(getBlocks()["real"].total.users) }}
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Users
                </span>
              </div>
            </div>
            <!-- /Users -->
          </div>
        </div>
        <!-- /All -->

        <!-- All orders -->
        <div class="card card-custom text-no-wrap">
          <div class="card-header border-0 d-flex">
            <h5 class="font-weight-bolder text-dark">
              <img src="/pages/dashboard/saving.svg" alt="" /><span
                >All orders</span
              >
            </h5>
          </div>
          <div class="card-body pt-0 d-flex">
            <div class="d-flex align-items-center flex xs4">
              <div class="d-flex flex-column" style="font-weight:900">
                <span class="font-size-h3 text-dark" v-if="!loading">
                  {{ formatNumbers(getBlocks()["real"].conversions) }}
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  Orders
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- /All orders -->
      </v-col>
      <!-- /Real -->
    </v-row>
    <!-- /Demo block -->

    <!-- CR of potentional blocked users -->
    <v-row class="justify-content-center">
      <v-col class="col-lg-3 align-self-center">
        <div class="card text-no-wrap">
          <div class="card-body d-flex">
            <div class="d-flex align-items-center my-0 flex">
              <div class="d-flex flex-column" style="font-weight:900">
                <span
                  class="font-size-h3"
                  style="color: #80001f"
                  v-if="!loadingTotals"
                >
                  {{ getTotals()["cr"].blocked }}%
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  CR of potentional blocked users
                </span>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- /CR of potentional blocked users -->

    <!-- CR of non-blocked users -->
    <v-row class="justify-content-center">
      <v-col class="col-lg-3 align-self-center">
        <div class="card text-no-wrap">
          <div class="card-body d-flex">
            <div class="d-flex align-items-center my-0 flex">
              <div class="d-flex flex-column" style="font-weight:900">
                <span
                  class="font-size-h3"
                  style="color: #28a745"
                  v-if="!loadingTotals"
                >
                  {{ getTotals()["cr"].non_blocked }}%
                </span>
                <v-skeleton-loader type="text" v-else></v-skeleton-loader>
                <span class="font-size-h7 font-weight-normal">
                  CR of non-blocked users
                </span>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- /CR of non-blocked users -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import currencies from "@/core/mixins/currencies.mixin";
//import sprintf from "@/core/libs/sprintf.lib";

export default {
  name: "DemoBlocks",
  mixins: [currencies],
  props: {
    dates: {
      type: Array,
      required: true
    },
    selectedDomains: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      loadingTotals: true,
      blocks: [],
      percents: [],
      icons: {
        clicks: "mdi-cursor-default",
        ips: "mdi-web",
        overlimit: "mdi-cancel",
        pages: "mdi-file-document-box-multiple-outline",
        placements: "mdi-file-document-box-remove-outline",
        prevented_clicks: "mdi-binoculars",
        saved_budget: "mdi-currency-usd",
        visitors: "mdi-account"
      },
      blocksTimestamp: 0,
      percentsTimestamp: 0
    };
  },
  watch: {
    dates: "getData",
    selectedDomains: "getData"
  },
  async mounted() {
    await this.getData();
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  methods: {
    async getData() {
      // no await for functions
      this.getDataBlocks();
      this.getDataPercents();
    },
    async getDataBlocks() {
      if (!this.selectedDomains.length) {
        return;
      }

      this.loading = true;

      let blocks = await this.$api.demo.getBlocks({
        dateFrom: this.dates[0],
        dateTo: this.dates[1] ?? this.dates[0],
        domains: this.selectedDomains.map(el => el.id),
        tableName: "demoTable"
      });

      if (blocks.timestamp > this.blocksTimestamp) {
        this.blocks = blocks;
        this.blocksTimestamp = blocks.timestamp;
      }

      this.loading = false;
    },
    async getDataPercents() {
      if (!this.selectedDomains.length) {
        return;
      }

      this.loadingTotals = true;

      let percents = await this.$api.demo.getPercents({
        dateFrom: this.dates[0],
        dateTo: this.dates[1] ?? this.dates[0],
        domains: this.selectedDomains.map(el => el.id),
        tableName: "demoTable"
      });

      if (percents.timestamp > this.percentsTimestamp) {
        this.percents = percents;
        this.percentsTimestamp = percents.timestamp;
      }

      this.loadingTotals = false;
    },
    getBlocks() {
      return {
        predicted: this.blocks.predicted,
        real: this.blocks.real,
        cr: this.blocks.cr
      };
    },
    getTotals() {
      return {
        cr: this.percents.cr
      };
    },
    prettyText(digit) {
      let k = "";
      while (digit / 1000 > 1) {
        digit = Math.round((digit / 1000) * 100) / 100;
        k += "k";
      }
      return digit * 1 + k;
    }
  }
};
</script>

<style scoped lang="scss">
h5 {
  img {
    margin-right: 5px;
  }
}

.text-no-wrap {
  white-space: nowrap;
}
</style>
